import { FC, useEffect, useRef } from "react";

import styles from "./Graphic.module.scss";

import { rawSvgGraphic } from "./rawSwgGraphip";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import formatExaminationDataValue from "@/utils/formatExaminationDataValue";
import {
  clearCurrentDataListener,
  listenCurrentData,
} from "@/store/reducers/currentData/asyncActionCreators";

const Graphic: FC = () => {
  const dispatch = useAppDispatch();
  const graphicRef = useRef<HTMLDivElement>(null);
  const registerRefs = useRef<Element[]>([]);

  const currentData = useAppSelector(
    (state) => state.currentDataReducer.currentData
  );

  useEffect(() => {
    dispatch(listenCurrentData());
    return () => {
      dispatch(clearCurrentDataListener());
    };
  }, [dispatch]);

  useEffect(() => {
    if (graphicRef.current && currentData) {
      Object.entries(formatExaminationDataValue(currentData)).forEach(
        ([key, value]) => {
          key = key.replace("%", "");
          key = key.replace(".", "");

          let element = registerRefs.current.find((ref) => ref.id === key);

          if (!element) {
            element = graphicRef.current!.querySelector("#" + key) || undefined;
            if (element) {
              registerRefs.current.push(element);
            }
          }

          if (element) {
            element.textContent = value.toString();
          }
        }
      );
    }
  }, [currentData]);

  return (
    <div className={styles.graphic}>
      <div
        ref={graphicRef}
        dangerouslySetInnerHTML={{ __html: rawSvgGraphic }}
      />
    </div>
  );
};

export default Graphic;
